import { cnTheme } from '@ps-int/360-components/dist/components/Theme';

import { theme as orbDark } from '../../themes/orb-migrate-dark';
import { theme as orbLight } from '../../themes/orb-migrate-light';

import '@yandex-360/orb-themes/css/brands/telemost.css';

import { ThemeValue } from '@yandex-360/orb-components/dist/components/Theme/types';

const { themes } = require('@ps-int/general-themes/themes');

// TODO: переделать на импорт как починятся типы в orb-themes
const { ORB_DARK } = require('@yandex-360/orb-themes/orb-dark');
const { ORB_LIGHT } = require('@yandex-360/orb-themes/orb-light');

const DEFAULT_THEME_NAME = 'ps-light-transparent';

const THEMES_MAP: { [key: string]: { color: string; root: string } } = {
    'ps-dark': orbDark,
    'ps-light-transparent': orbLight,
    'ps-dark-transparent': orbDark,
    'ps-superdark-transparent': orbDark,
    dark: orbDark,
    light: orbLight,
};

export const isDarkTheme = (themeName: string | null | undefined) =>
    themeName && ['ps-dark', 'general-grass', 'general-darkflow', 'dark'].includes(themeName);

const getBlockThemeName = (themeName: string | null | undefined, block: 'content' | 'page') => {
    if (!themeName) {
        return DEFAULT_THEME_NAME;
    }
    if (themes[themeName]) {
        return themes[themeName][block].base.root;
    }
    if (THEMES_MAP[themeName]) {
        return themeName;
    }

    return DEFAULT_THEME_NAME;
};

export const getOrbThemeClassName = (theme: ThemeValue) => cnTheme(theme === 'dark' ? ORB_DARK : ORB_LIGHT);

export const getThemeClassName = (theme: ThemeValue) => {
    return [getOrbThemeClassName(theme), cnTheme(theme === 'dark' ? orbDark : orbLight)].join(' ');
};

const getBlockClassName = (themeName: string | null | undefined, block: 'content' | 'page', isInverse?: boolean) => {
    let blockThemeName = getBlockThemeName(themeName, block);
    if (isInverse) {
        blockThemeName = blockThemeName === DEFAULT_THEME_NAME ? 'ps-dark' : DEFAULT_THEME_NAME;
    }

    const theme = THEMES_MAP[blockThemeName];
    return cnTheme(theme);
};

export const getPageClassName = (themeName: string | null | undefined, isInverse?: boolean) =>
    getBlockClassName(themeName, 'page', isInverse);

export const getPageOverrides = (themeName: string | null) => {
    if (!themeName || !themes[themeName]) {
        return DEFAULT_THEME_NAME;
    }

    return themes[themeName].page.override;
};
